import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Row, Col, Modal, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import MediaManager from '../../Media/MediaManager';
import { useForm } from 'antd/es/form/Form';
import { useBrands } from '../Brands/BrandStore';
import { useModels } from '../Models/ModelStore';
import { useCategorys } from '../Categorys/CatStore';
import { useUnits } from '../Units/UnitStore';
import { useProducts } from './ProductStore';
import { MAIN_URL } from '../../../Constants';

const Edit = () => {
    const [form] = useForm();
    let [main_img, setMain_img] = useState(null)
    let [gallery_img, setGallery_img] = useState([])
    let [modal, setModal] = useState(false)
    let [gal_modal, setGal_modal] = useState(false)
    let { brands, getBrands } = useBrands()
    let { models, getModels } = useModels()
    let { categorys, getCategories } = useCategorys()
    let { units, getUnits } = useUnits()


    let { ed, updateProduct } = useProducts()

    useEffect(() => {
        getBrands()
        getModels()
        getCategories()
        getUnits()
    }, [])

    const handleSelect = (e) => {
        setMain_img(e)
    }

    const handleGallerySelect = (e) => {
        setGallery_img([...gallery_img, e])
    }
    useEffect(() => {
        form.setFieldsValue({
            img: main_img
        })
    }, [main_img])

    useEffect(() => {
        form.setFieldsValue({
            gallery: gallery_img
        })
    }, [gallery_img])

    let handleGalDelete = (index) => {
        let newGal = gallery_img.filter((item, i) => i !== index)
        setGallery_img(newGal)
    }
    useEffect(() => {
        form.setFieldsValue(ed)
        setMain_img(ed.img)
        if (!ed?.gallery) return
        let newGal = ed?.gallery

        setGallery_img(newGal)
    }, [ed])

    return (
        <>
            <Modal width={'80%'} open={modal} footer={null} onCancel={() => setModal(false)}>
                <MediaManager onSelect={handleSelect} />
            </Modal>
            <Modal width={'80%'} open={gal_modal} footer={null} onCancel={() => setGal_modal(false)}>
                <MediaManager onSelect={handleGallerySelect} />
            </Modal>
            <Form
                form={form}
                layout="vertical"
                onFinish={updateProduct}
                autoComplete="off"
            >
                <Form.Item name={'id'} hidden>
                    <Input />
                </Form.Item>
                <fieldset>
                    <legend>Asosiy Ma'lumotlar</legend>
                    <Form.Item
                        name="nameuz"
                        label="Name (UZ)"
                        rules={[{ required: true, message: 'Please input name in Uzbek!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="nameru"
                        label="Name (RU)"
                        rules={[{ required: true, message: 'Please input name in Russian!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="category_id"
                        label="Category"
                    >
                        <Select
                            showSearch
                            placeholder="Category"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {categorys.map((category) => (
                                <Select.Option key={category.id} value={category.id}>
                                    {category.nameuz}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="descuz"
                        label="Description (UZ)"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>
                    <Form.Item
                        name="descru"
                        label="Description (RU)"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>
                    <Form.Item
                        name="img"
                        label="Main Image"
                    >
                        <Input readOnly suffix={<Button type="primary" onClick={() => setModal(true)}>Fayl yuklash</Button>} />
                    </Form.Item>
                    {main_img && <img src={main_img} alt="" style={{ width: '100px' }} />}
                    <Form.Item
                        name="gallery"
                        label="Gallery"
                    >
                        <Input disabled suffix={<Button type="primary" onClick={() => setGal_modal(true)}>Fayl yuklash</Button>} />
                    </Form.Item>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {gallery_img?.length > 0 && gallery_img?.map((item, index) => (
                            <div key={index} style={{ position: 'relative' }}>
                                <img src={MAIN_URL + '/' + item} alt="" style={{ width: '100px', height: '100px', objectFit: 'cover', margin: '5px' }} />
                                <Button icon={<DeleteOutlined />} shape='circle' type='primary' size='small' danger onClick={() => handleGalDelete(index)} style={{ position: 'absolute', top: '0px', right: '0px', border: '1px solid #fff' }} />
                            </div>
                        ))}
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Qo'shimcha parametrlar</legend>
                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item
                                name="min_count"
                                label="Minimal qoldiq"
                            >
                                <Input type='number' />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="brand_id"
                                label="Marka"
                            >
                                <Select
                                    showSearch
                                    placeholder="Marka"
                                    optionFilterProp="children"
                                    mode="multiple"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {brands.map((brand) => (
                                        <Select.Option key={brand.id} value={brand.id}>
                                            {brand.nameuz}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="model_id"
                                label="Model"
                            >
                                <Select
                                    showSearch
                                    placeholder="Model"
                                    mode="multiple"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {models.map((model) => (
                                        <Select.Option key={model.id} value={model.id}>
                                            {model.nameuz}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="unit_id"
                                label="Birlik"
                            >
                                <Select
                                    showSearch
                                    placeholder="Birlik"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {units.map((unit) => (
                                        <Select.Option key={unit.id} value={unit.id}>
                                            {unit.nameuz}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="newto"
                                label="Yangi qilib belgilash"
                                valuePropName="checked"
                            >
                                <Switch />
                            </Form.Item>
                        </Col>
                    </Row>
                </fieldset>
                <fieldset>
                    <legend>SEO Ma'lumotlar</legend>
                    <Form.Item
                        name="meta_desc"
                        label="Meta Description"
                    >
                        <Input.TextArea rows={2} />
                    </Form.Item>
                    <Form.Item
                        name="meta_keywords"
                        label="Meta Keywords"
                    >
                        <Input.TextArea rows={2} />
                    </Form.Item>
                </fieldset>



                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Qo'shish
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
};

export default Edit;